// Rutas base de Nuvex Access. Vive aparte de config.tsx para que las pantallas
// puedan enlazar entre sí sin importar config (que importa las pantallas).
export const NUVEX_ACCESS_BASE = "/nuvex-access";

/**
 * Sub app «Rondines» de Bases y Propiedades (épica CC-CONSOLE #1591): la ruta
 * `/rondines` (índice → `/rondines/tablero`) llega con la rama
 * feat/ivms-bases-rondines; mientras no se mergee, el enlace cae en el 404.
 */
export const RONDINES_ROUTE = "/rondines/tablero";
